import { useSearchParams } from 'react-router-dom';
import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';
import { imageUrl } from '../lib/images';

export default function KontaktPage() {
  const [searchParams] = useSearchParams();
  const packageParam = searchParams.get('pakke');
  const serviceParam = searchParams.get('ydelse');

  let defaultSubject = '';
  if (packageParam) {
    defaultSubject = `bryllupspakken "${packageParam}"`;
  } else if (serviceParam === 'cykelloeb') {
    defaultSubject = 'cykelløb';
  } else if (serviceParam === 'event') {
    defaultSubject = 'event- & erhvervsdækning';
  } else if (serviceParam === 'familie') {
    defaultSubject = 'familiefotografering';
  }

  return (
    <>
      <SEO
        title="Kontakt"
        description="Kontakt Lunde Media v/ Michael for en uforpligtende snak om dit næste foto- eller videoprojekt. Telefon 26 36 83 06 eller kontaktformular."
      />

      {/* Page Header (Cinematic Dark) */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 bg-[#0C0C0D] border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-medium text-[#F4EFEA] tracking-tight">
              Lad os tage en snak om dine visuelle ønsker
            </h1>
            <p className="text-zinc-400 text-base md:text-lg leading-relaxed font-sans">
              Har du en dato i kalenderen, en forespørgsel på et bryllup, et cykelløb, et event eller familiebilleder? Ring eller send en besked – jeg svarer hurtigt og uforpligtende.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content: Info & Form in Warm Light Section */}
      <section className="py-20 md:py-28 bg-white text-[#141416] border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Contact Details (col 1-5) */}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-4">
                <h2 className="text-3xl font-serif text-[#141416]">
                  Kontaktoplysninger
                </h2>
                <p className="text-[#575450] text-sm md:text-base leading-relaxed">
                  Det skal være nemt og uformelt at tage kontakt. Du er altid velkommen til at gribe telefonen eller sende en besked via formularen.
                </p>
              </div>

              {/* Contact Cards */}
              <div className="space-y-4">
                {/* Telefon */}
                <div className="group p-6 rounded-none bg-white border border-zinc-200 shadow-sm flex items-start gap-4 transition-colors">
                  <div className="text-black pt-1 shrink-0">
                    <i className="fa-solid fa-phone text-lg" aria-hidden="true" />
                  </div>
                  <div className="space-y-1">
                    <a
                      href="tel:26368306"
                      className="text-xl font-serif font-medium text-[#141416] hover:text-black transition-colors whitespace-nowrap block"
                    >
                      26 36 83 06
                    </a>
                    <p className="text-xs text-[#6E6A63]">
                      Hverdage & weekender efter aftale
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="group p-6 rounded-none bg-white border border-zinc-200 shadow-sm flex items-start gap-4 transition-colors">
                  <div className="text-black pt-1 shrink-0">
                    <i className="fa-solid fa-envelope text-lg" aria-hidden="true" />
                  </div>
                  <div className="space-y-1">
                    <a
                      href="mailto:Kontakt@lundemedia.dk"
                      className="text-base sm:text-lg font-sans font-medium text-[#141416] hover:text-black transition-colors whitespace-nowrap block"
                    >
                      Kontakt@lundemedia.dk
                    </a>
                    <p className="text-xs text-[#6E6A63]">
                      Svarer hurtigt inden for 24 timer
                    </p>
                  </div>
                </div>

                {/* Lokation / Base */}
                <div className="group p-6 rounded-none bg-white border border-zinc-200 shadow-sm flex items-start gap-4 transition-colors">
                  <div className="text-black pt-1 shrink-0">
                    <i className="fa-solid fa-location-dot text-lg" aria-hidden="true" />
                  </div>
                  <div className="space-y-1">
                    <div className="text-base font-serif text-[#141416]">
                      Holder til i Kolding
                    </div>
                    <p className="text-xs text-[#6E6A63] pt-1">
                      Kører ud til opgaver i hele landet
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form (col 6-12) */}
            <div className="lg:col-span-7">
              <div className="mb-6">
                <h3 className="text-2xl font-serif text-[#141416]">
                  Send en uforpligtende forespørgsel
                </h3>
                <p className="text-xs text-[#575450] mt-1">
                  Udfyld formularen, så vender jeg tilbage med svar og eventuelle opklarende spørgsmål.
                </p>
              </div>
              <ContactForm defaultSubject={defaultSubject} theme="light" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
